{
  "Accessibility Menu": "ადაპტირებული მენიუ",
  "Reset settings": "პარამეტრების დაბრუნება",
  "Close": "დახურვა",
  "Content Adjustments": "შიგთავსის მორგება",
  "Adjust Font Size": "ფონტის ზომის მორგება",
  "Highlight Title": "სათაურების გამოყოფა",
  "Highlight Links": "ბმულების გამოყოფა",
  "Readable Font": "წაკითხვადი ტექსტები",
  "Color Adjustments": "ფერების მორგება",
  "Dark Contrast": "ბნელი ელფერი",
  "Light Contrast": "ნათელი ელფერი",
  "High Contrast": "მაღალი ელფერი",
  "High Saturation": "მაღალი გაჯერება",
  "Low Saturation": "დაბალი გაჯერება",
  "Monochrome": "ერთფეროვანი გამოსახულება",
  "Tools": "ხელსაწყოები",
  "Reading Guide": "კითხვის გამყოლი ზოლი",
  "Stop Animations": "ანიმაციების გაჩერება",
  "Big Cursor": "დიდი კურსორი",
  "Increase Font Size": "ფონტის ზომის გაზრდა",
  "Decrease Font Size": "ფონტის ზომის შემცირება",
  "Letter Spacing": "ასოებს შორის დაშორება",
  "Line Height": "ხაზის სიმაღლე",
  "Font Weight": "ფონტის წონა",
  "Dyslexia Font": "დისლექსიური ფონტი",
  "Language": "ენა",
  "Open Accessibility Menu": "გახსენი ადაპტირებული მენიუ"
}
